/**
 * Brand logo — uses the tightly-cropped promo asset (less internal whitespace
 * than the original Logo.jpg), so smaller sizes still look great.
 */
const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_yambukai-finance/artifacts/2jotyouh_Promo-Facebook-Facebook%20cover%20photo.jpeg";

const SIZES = {
  sm: "h-16",   // dashboard topbar
  md: "h-20",   // public navbar
  lg: "h-24",   // footer / splash
};

export default function BrandLogo({ size = "md", className = "" }) {
  const h = SIZES[size] || SIZES.md;
  return (
    <img
      src={LOGO_URL}
      alt="Joseph Roberts Capital"
      className={`${h} w-auto shrink-0 select-none object-contain ${className}`}
      draggable="false"
    />
  );
}
